import {Component, EventEmitter, Inject, Input, OnInit, Output} from 'ng-metadata/core';
import './menu-trigger-button.component.scss';
import {IRootElementService} from "angular";

/**
 * @ngdoc directive
 * @name mwMenuTriggerButton
 * @module mw.components.menu
 *
 * @param {string} [aria-label] - The aria-label that should be applied to the menu trigger button.
 * @param {string} [btn-class] - Add additional class to the button if you need to override/customize the button styles.
 * @param {string} [icon] - Name of an icon to be added to the button.  Should be in the same format supported by the 'md-svg-icon' param of an `<md-icon>`.
 * @param {string} [icon-size] - Size of the icon to be displayed as in `<mw-icon size="size">`.
 * @param {string} [dropdown-icon="navigation:ic_arrow_drop_down_24px"] - Name of an icon to be added to the dropdown.  Should be in the same format supported by the 'md-svg-icon' param of an `<md-icon>`.
 * @param {string} [tooltip] - The text that should be displayed as tooltip on hover of the button.
 * @param {string} [tooltip-direction] - The direction that the tooltip is shown, relative to the parent element. Supports top, right, bottom, and left. Defaults to bottom.
 * @param {expression} [on-click] - Angular expression to evaluate when the button is clicked.  $event is the ng-click event.
 *
 * @description
 * `<mw-menu-trigger-button>` is a standard text button component that can be used inside an `<md-menu>` to trigger opening the menu.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- Single Select Dropdown usage example -->
 *   <mw-menu-trigger-button tooltip="{{'Open Menu' | translate}}" on-click="$mdOpenMenu($event)">{{$ctrl.selectedItem}}</mw-menu-trigger-button>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-menu-trigger-button',
    template: `
        <md-button class="mw-menu-trigger-button" ng-class="{'md-icon-button': $ctrl.icon, '{{$ctrl.btnClass}}': $ctrl.btnClass}" aria-label="$ctrl.ariaLabel" ng-click="$ctrl.handleClick($event)" md-no-ink>
            <md-tooltip md-direction="$ctrl.tooltipDirection" md-delay="500" md-z-index="99">
                {{$ctrl.tooltip}}
            </md-tooltip>
            <md-icon ng-if="$ctrl.icon" md-svg-src="{{ $ctrl.icon }}"></md-icon>
            <div ng-if="!$ctrl.icon" >
                <ng-transclude ng-transclude-slot="mdIcon"></ng-transclude>
                <ng-transclude ng-transclude-slot="mwIcon"></ng-transclude>
                <ng-transclude class="mw-menu-trigger-button__label"></ng-transclude>
                <mw-icon size="{{$ctrl.iconSize}}" svg-icon="{{$ctrl.dropdownIcon}}"></mw-icon>
            </div>
        </md-button>
      `,
    legacy: {
        transclude: {
            mdIcon: '?mdIcon',
            mwIcon: '?mwIcon'
        }
    }
})
export class MenuTriggerButtonComponent implements OnInit {
    @Input('@') ariaLabel: string;
    @Input('@') btnClass: string;
    @Input('@') icon: string;
    @Input('@') iconSize: string;
    @Input('@') tooltip: string;
    @Input('@') tooltipDirection: string;
    @Input('@') dropdownIcon: string = 'navigation:ic_arrow_drop_down_24px';
    @Output() onClick = new EventEmitter<ng.IAngularEvent>();


    constructor(@Inject('$element') private $element: IRootElementService) {
        'ngInject';
    }

    ngOnInit() {
        const el = this.$element;
        if (el.length && el[0].className.indexOf('mw-menu-trigger-button--outlined') > -1) {
            this.iconSize = '';
        }else {
            this.iconSize = this.iconSize ? this.iconSize : 'small';
        }
    }

    handleClick(event: ng.IAngularEvent) {
        this.onClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/menu/menu-trigger/menu-trigger-button.component.ts